export default "__VITE_ASSET__D1riq299__"